import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-display-language-setting',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, TranslatePipe],
  templateUrl: './display-language-setting.component.html',
  styleUrl: './display-language-setting.component.scss'
})
export class DisplayLanguageSettingComponent {
  constructor(private readonly dialogRef: MatDialogRef<DisplayLanguageSettingComponent>) {}

  closeDialog(): void {
    this.dialogRef.close(true);
  }
}
